exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__App__app__Ei2UT {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 10px 15px;\n  position: relative;\n}\n\n.dmb-web__App__optionsContainer__SUqw- {\n  position: absolute;\n  right: 10px;\n  top: 20px;\n  z-index: 2;\n}\n\n.dmb-web__App__segmentController__2msxZ {\n  position: relative;\n}\n\n/* specificity is strong for this one */\ndiv.dmb-web__App__forecastWeatherTab__46mZU {\n  color: #FFF;\n}\n\n.dmb-web__App__segmentTabIcon__09nHs > svg {\n  position: relative;\n  right: 5px;\n  top: 2px;\n}\n\n.dmb-web__App__pastWeatherPaywall__FphF0[class^='crate__Modal'] {\n  margin-top: 30dvh;\n}\n", ""]);

// exports
exports.locals = {
	"app": "dmb-web__App__app__Ei2UT",
	"optionsContainer": "dmb-web__App__optionsContainer__SUqw-",
	"segmentController": "dmb-web__App__segmentController__2msxZ",
	"forecastWeatherTab": "dmb-web__App__forecastWeatherTab__46mZU",
	"segmentTabIcon": "dmb-web__App__segmentTabIcon__09nHs",
	"pastWeatherPaywall": "dmb-web__App__pastWeatherPaywall__FphF0"
};